


















































import { Component, Vue, Watch, InjectReactive } from 'vue-property-decorator'
import RestClient from '../components/RestClient.vue'
import Account from '../account'
import AccessToken from '../access-token'

@Component
export default class VueComponent extends Vue {
    $log: any
    @InjectReactive() account?: Account
    @InjectReactive() restClient!: RestClient
    tokens?: AccessToken[]
    selectedToken?: AccessToken
    data() {
        return {
            tokens: null,
            selectedToken: null,
        }
    }
    @Watch('$route', { immediate: true, deep: true })
    routed() {
        if (this.$route.path == '/dashboard') {
            this.$router.push('/dashboard/elevation_tokens')
        }
    }
    mounted() {
        this.refresh()
    }
    @Watch('tokens')
    invalidateSelectedToken() {
        if (this.tokens && this.selectedToken) {
            for (var i = 0 ; i < this.tokens.length; i++) {
                if (this.tokens[i].id == this.selectedToken.id) {
                    return
                }
            }
        }
        this.selectedToken = undefined
    }
    @Watch('account')
    refresh() {
        if (this.account) {
            this.restClient.request('GET', '/v1/access_tokens?scope=' + encodeURIComponent('elevation:read'), null, (data) => {
                if (data.tokens) {
                    var tokens: AccessToken[] = []
                    data.tokens.forEach((json: any) => {
                        let token = AccessToken.unmarshal(json)
                        if (token) {
                            tokens.push(token)
                        }
                    })
                    this.tokens = tokens
                } else {
                    this.tokens = []
                }
            })
        }
    }
    get baseUrl() {
        var url = window.location
        return url.protocol + "//" + url.host
    }
}
